import styled from 'styled-components'

export const StyledMultipleAddressItems = styled.div`
  position: relative;
  margin-top: ${props => props.theme.spacing.default};

  &:hover {
    & > div {
      opacity: 1;
    }
  }
`

export const StyledMultipleAddressItemsButton = styled.button`
  border-radius: ${props => props.theme.radius.small};
  background-color: ${props => props.theme.colors.secondary[25]};
  border: 1px solid ${props => props.theme.colors.secondary[100]};
  color: ${props => props.theme.colors.secondary[500]};
  padding: 0;
  width: 2rem;
  height: 2rem;
`

export const StyledMultipleAddressItemsList = styled.div`
  position: absolute;
  z-index: 2;
  top: 2.1rem;
  left: 0;
  padding: ${props => props.theme.spacing.default};
  border-radius: ${props => props.theme.radius.small};
  background-color: ${props => props.theme.colors.secondary[25]};
  border: 1px solid ${props => props.theme.colors.secondary[100]};
  font-size: ${props => props.theme.font.small};
  transition: all 0.16s ease-in-out;
  opacity: 0;

  * {
    pointer-events: none;
  }
`

export const StyledMultipleAddressItemsListItem = styled.div`
  padding-block: ${props => props.theme.spacing.small};
`
